import { render, staticRenderFns } from "./SupplierTable.vue?vue&type=template&id=8ff5839a&scoped=true"
import script from "./SupplierTable.vue?vue&type=script&lang=js"
export * from "./SupplierTable.vue?vue&type=script&lang=js"
import style0 from "./SupplierTable.vue?vue&type=style&index=0&id=8ff5839a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff5839a",
  null
  
)

export default component.exports